export default __webpack_public_path__ + "static/media/image_organize_publish.66f2cd07.svg";